import type { FlexProps } from "@ecco/ui/flex";
import type { BoxProps } from "@ecco/ui/box";
import { scrollbarStyles } from "@ecco/ui/css/scrollbar";

export const parentContainerStyles: BoxProps["sx"] = {
    position: "relative",
    minH: "114px",
};

export const containerStyles: FlexProps["sx"] = {
    display: "flex",
    maxWidth: "100vw",
    flexWrap: "nowrap",
    overflowY: "hidden",
    ...scrollbarStyles,
    justifyContent: ["flex-start"],
    pt: [6, 6, 8],
    pb: [6, 6, 16],
    mb: [6, 6, 0],
    ml: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
    mr: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
    position: "absolute",
    left: 0,
    /* We are using negative value to avoid cut the scroll area */
    right: "-16px",
    pr: [4, 0],
    "::-webkit-scrollbar-track": {
        background: "gray.200",
        marginRight: [4, 4, 0],
    },
};

export const itemStyles: FlexProps["sx"] = {
    gap: 4,
    flexWrap: "nowrap",
    width: "auto",
};
